<template>
    <v-container class="row-padding" grid-list-xl fluid>
        <v-card class="item-card mx-auto mb-0" style="z-index:10" elevation="50" flat>
            <v-toolbar color="black" dense dark>
                <!-- HEADER -->
                <v-app-bar-nav-icon></v-app-bar-nav-icon>

                <v-toolbar-title v-if="corpusDocument">
                    Carta - {{ corpusDocument["name"] }}
                </v-toolbar-title>

                <v-spacer></v-spacer><span v-if="currentTime">{{ }}</span>

                <v-btn icon>
                    <v-icon>book</v-icon>
                </v-btn>

                <v-btn v-if="corpusDocument && corpusDocument['is_segmented']" icon>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on" @click="visualization_dialog = true">mdi-eye-settings</v-icon>
                        </template>
                        "Opciones de visualización"
                    </v-tooltip>
                </v-btn>

                <!-- FILTERS SECTION -->
                <v-dialog v-if="corpusDocument" v-model="visualization_dialog" max-width="370">
                    <v-container class="pa-0" fluid>
                        <!--style="width:650px"-->
                        <v-row no-gutters justify="center">
                            <v-col cols="12" class="pa-0">
                                <v-card class="pa-5 filter-color">
                                    <v-card-title class="filter-color py-0" style="min-height:10px" hide-actions dense>
                                        <h3 class="filter-color font-weight-bold text-center" style="line-height:10px">
                                            Opciones de visualización
                                        </h3>
                                    </v-card-title>

                                    <v-card-text class="filter-color pa-0 ma-0"
                                        style="padding:0px !important;font-size:90%">
                                        <!--UNITS VISUALIZATION SECTION-->
                                        <v-container class="filter-color pa-0" fluid>
                                            <v-card class="filter-row-color my-3 search-value-col" outlined>
                                                <v-row no-gutters justify="start">
                                                    <v-row no-gutters justify="start">
                                                        <v-col class="search-value-col mr-12" cols="auto">
                                                            <v-checkbox v-if="corpusDocument['is_segmented']" dense
                                                                hide-details="true"
                                                                v-model="visualizationForm['units']['speeches']"
                                                                label="Discursos"></v-checkbox>
                                                            <v-checkbox v-if="corpusDocument['is_segmented']" dense
                                                                hide-details="true"
                                                                v-model="visualizationForm['units']['dialogs']"
                                                                label="Diálogos"></v-checkbox>
                                                            <v-checkbox dense hide-details="true"
                                                                v-model="visualizationForm['units']['interventions']"
                                                                label="Intervenciones"></v-checkbox>
                                                        </v-col>
                                                        <v-col class="search-value-col mr-12" cols="auto">
                                                            <!--<v-checkbox dense hide-details="true" v-model="visualizationForm['units']['turns']" label="Turnos"></v-checkbox>-->
                                                            <v-checkbox v-if="corpusDocument['is_segmented']" dense
                                                                hide-details="true"
                                                                v-model="visualizationForm['units']['acts']"
                                                                label="Actos"></v-checkbox>
                                                            <v-checkbox v-if="corpusDocument['is_segmented']" dense
                                                                hide-details="true"
                                                                v-model="visualizationForm['units']['subacts']"
                                                                label="Subacts"></v-checkbox>
                                                        </v-col>
                                                    </v-row>
                                                </v-row>
                                            </v-card>
                                        </v-container>

                                        <v-row no-gutters justify="end">
                                            <v-col cols="auto">
                                                <v-btn class="mr-3" color="white"
                                                    @click="loadInterventions(); visualization_dialog = false;" small>
                                                    Filtrar
                                                </v-btn>
                                                <v-btn class="mr-3" color="white" @click="resetVisualizationSection();"
                                                    small>
                                                    Borrar
                                                </v-btn>
                                                <v-btn class="mr-3" color="white" @click="visualization_dialog = false;"
                                                    small>
                                                    Cerrar
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-dialog>
            </v-toolbar>
        </v-card>
        <v-container id="letter-carousel">
            <!-- {{ this.$mout.object.keys(this.pagesMap).length }} -->
            <span style="display: none;">{{ this.movements.length }}</span>
            <v-container class="row-padding">
                <v-row no-gutters justify="center">
                    <template>
                        <v-carousel style="width:100%;height: 700px;" height="700" continuous hide-delimiter-background>
                            <v-carousel-item v-for="(page, i, index) in pagesMap" :key="i"
                                style="padding: 0px 100px !important;">
                                <v-row justify="center">
                                    <h2>Página {{ index + 1 }}</h2>
                                </v-row>
                                <v-row>
                                    <v-col cols="4">
                                        <v-card>
                                            <v-container>
                                                <v-row>
                                                    <div class="letter-image-container">
                                                        <!-- <v-img src="./img/valesco_logo.png" height="150"
                                                            contain></v-img> -->

                                                        <expandable-image :src="page['image']['data']" />

                                                        <!-- <img :src="page['image']['data']" /> -->
                                                    </div>
                                                </v-row>
                                            </v-container>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="8">
                                        <v-card class="pa-0" elevation="50" raised>
                                            <!-- LETTERS GRID -->
                                            <v-card id="scroll-target" class="item-card scroll-y px-0"
                                                style="overflow: scroll; overflow-x: hidden;z-index:0" height="500"
                                                flat>

                                                <v-data-table id="letters" v-scroll:#scroll-target="onScroll"
                                                    v-model="selected_rows" align-center justify-center
                                                    disable-pagination class="transparent" locale="es-ES"
                                                    :headers="headers" :items="page['movements']" item-key="cod"
                                                    :search="search" hide-default-footer dense
                                                    :loading="movements_loading" loading-text="Cargando datos..."
                                                    no-data-text="No se han encontrado resultados">

                                                    <template v-slot:item="{ item, index }">
                                                        <tr :id="'row_' + item['cod']" :key="item.cod"
                                                            :class="[selected_class_rows_map[item.cod] ? 'selected' : item.is_observation ? 'observation' : item.is_direct_speech ? 'directSpeech' : '']"
                                                            @click="rowClicked(item)">
                                                            <!-- <td class="text-center body-1" style="font-family: monospace !important;"
                                v-html="item.conversation_speaker">
                            </td> -->
                                                            <td class="text-xs-center">
                                                                {{ item.cod }}
                                                            </td>
                                                            <td class="text-xs-center">
                                                                {{ item.paragraph }}
                                                            </td>
                                                            <td>
                                                                <p class="text-left body-1" style="color:#000"
                                                                    v-html="item.cleaned_contents">
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </v-data-table>
                                            </v-card>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-carousel-item>
                        </v-carousel>
                    </template>
                </v-row>
            </v-container>
        </v-container>
    </v-container>
</template>

<script>
import api from '@/restApi';
import { Breadcrumb, Loading } from '@/components';

export default {
    name: 'letter-viewer',
    bodyClass: 'default-page',
    props: {
        code: {
            type: String,
            default() {
                return "";
            }
        }
    },
    data() {
        return {
            debug: false,
            visualization_dialog: false,
            visualizationForm: {
                units: {
                    speeches: false,
                    dialogs: false,
                    //                        turns: true,
                    letters: false,
                    acts: false,
                    subacts: false
                }
            },
            selected_class_rows_map: {},
            corpusDocument: null,
            movements: [],
            search: "",
            selected_rows: [],
            conversation_speakers: null,
            expanded: [],
            shiftKeyOn: false,
            current: [],
            selectedRows: [],
            interventionInterval: null,
            pagesMap: {},
            headers: [
                //                    {
                //                        text: "",
                //                        align: "left",
                //                        value: "cod",
                //                        sortable: false
                //                    },
                //                    {
                //                        text: "Id",
                //                        align: "left",
                //                        value: "cod",
                //                        sortable: false
                //                    },
                {
                    text: "Cod",
                    align: "center",
                    value: "cod",
                    sortable: false,
                    width: 100
                },
                {
                    text: "Párrafo",
                    align: "left",
                    value: "paragraph",
                    sortable: false,
                    width: 100
                },
                {
                    text: "Contenido",
                    align: "center",
                    value: "metadata-contents",
                    sortable: false
                },
                // {
                //     text: "Fin",
                //     align: "center",
                //     value: "end",
                //     sortable: false
                // },
                //                    {
                //                        text: "Duración",
                //                        align: "center",
                //                        value: "duration",
                //                        sortable: false
                //                    }
            ],
            movements_loading: true,
            // PLAYER VARIABLES
            currentTime: 0
        };
    },
    computed: {
    },
    created: function () {
        this.loadConversationData();
    },
    beforeDestroy() {
    },
    mounted: function () {
    },
    watch: {
        selected_rows: function () {
            var self = this;

            //                console.log("Selected rows changed...");

            if (self.$mout.lang.isEmpty(self.selected_rows)) {
                return;
            }

            //                console.log("Selected rows", self.selected_rows);

            self.selected_class_rows_map = {};
            self.$mout.array.filter(self.selected_rows, function (item) {
                self.selected_class_rows_map[item["cod"]] = true;
            });
            var elem = document.getElementById("row_" + self.selected_rows[0]["cod"]);
            var pos = self.getElementPosition(elem);
            //                console.log("Row position " + JSON.stringify(pos));
            //                console.log(JSON.stringify("Row height " + elem.offsetHeight));
            //                alert(pos.x + "," + pos.y);

            self.gotoPosition(pos.y - elem.offsetHeight);
        }
    },
    methods: {
        rowClicked(row) {
            var self = this;

            console.log(row);
            self.waveSurferPlayer.seekTo(row["start"]);
        },
        goToRow() {
            var self = this;

            console.log("Get row...");

            self.selectInterventionsByCurrentTime(self.selected_row);
        },
        getElementPosition(theElement) {
            var posX = 0;
            var posY = 0;
            //                console.log(JSON.stringify("A " + theElement.offsetTop));
            while (theElement !== null) {
                posX += theElement.offsetLeft;
                posY += theElement.offsetTop;
                theElement = theElement.offsetParent;
            }

            return { x: posX, y: posY };
        },
        onScroll(e) {
            this.offsetTop = e.target.scrollTop;
        },
        gotoPosition(newPosition) {
            let container;
            let event;

            //                console.log("Go to position...");

            container = document.getElementById('scroll-target');
            event = new CustomEvent('scroll', {});

            container.pageYOffset = 0;
            newPosition = newPosition - 400;
            //                newPosition = newPosition - 600;

            //                setTimeout(() => {
            //                    console.log("Moving scroll to top " + newPosition);
            container.scrollTop = newPosition;
            //                }, 200);

            container.dispatchEvent(event);
        },
        async loadConversationData() {
            this.loadLetter();
            this.loadMovements();
        },
        async loadLetter() {
            var queryString;
            var self = this;

            queryString = "cod=" + self.code + "&fields=cod,name,is_segmented";

            // Get all corpus documents
            self.corpusDocument = await api.get("corpus_document", queryString);

            self.corpusDocument = self.corpusDocument[0];
        },
        async loadMovements() {
            var filter, populate, fields, sort, binary, queryString, visualizationOptions,
                segmentationFilter, debug;
            var self = this;

            this.movements_loading = true;

            debug = "";
            //                visualizationOptions = "turns,letters";
            // if (this.code === "046" || this.code === "002" || this.code === "042" ||
            //     this.code === "043" || this.code === "044") {
            //     self.debug = true;
            //     debug = "&debug=true";
            // }

            // VISUALIZATION OPTIONS
            visualizationOptions = "";
            if (self.visualizationForm["units"]["speeches"]) {
                visualizationOptions += "speeches,";
            }
            if (self.visualizationForm["units"]["dialogs"]) {
                visualizationOptions += "dialogs,";
            }
            //                if (self.visualizationForm["units"]["turns"]) {
            //                    visualizationOptions += "turns,";
            //                }
            if (self.visualizationForm["units"]["letters"]) {
                visualizationOptions += "letters,";
            }
            if (self.visualizationForm["units"]["acts"]) {
                visualizationOptions += "acts,";
            }
            if (self.visualizationForm["units"]["subacts"]) {
                visualizationOptions += "subacts";
            }

            if (!self.$mout.lang.isEmpty(visualizationOptions)) {
                visualizationOptions = self.$mout.string.rtrim(visualizationOptions, ",");
            }

            filter = "corpus_document.cod=" + this.code;
            segmentationFilter = !self.$mout.lang.isEmpty(visualizationOptions) ? "&segmentation_options=" + visualizationOptions : "";
            fields = "&fields=cod,cleaned_contents,order,image,paragraph,movement__corpus_document_page_list";
            sort = "&sort={\"field\":\"order\",\"dir\":\"asc\"}";
            populate = "&populate=movement__corpus_document_page_list.corpus_document_page";
            binary = "&binary=movement__corpus_document_page_list.corpus_document_page.image";

            queryString = filter + segmentationFilter + populate + fields + sort + binary + "&pageSize=0" + debug;

            // Get all movements
            this.movements = await api.getAllItems("movement", queryString);

            for (let movement of this.movements) {
                if (!movement["movement__corpus_document_page_list"]) {
                    continue;
                }

                for (let pageRelated of movement["movement__corpus_document_page_list"]) {
                    if (self.$mout.lang.isEmpty(this.pagesMap[pageRelated["corpus_document_page"]["_id"]])) {
                        this.pagesMap[pageRelated["corpus_document_page"]["_id"]] = pageRelated["corpus_document_page"];
                    }

                    if (self.$mout.lang.isEmpty(this.pagesMap[pageRelated["corpus_document_page"]["_id"]]["movements"])) {
                        this.pagesMap[pageRelated["corpus_document_page"]["_id"]]["movements"] = []
                    }

                    this.pagesMap[pageRelated["corpus_document_page"]["_id"]]["movements"].push(self.$mout.object.omit(movement, ["movement__corpus_document_page_list"]));
                }
            }

            self.movements_loading = false;
        },
        async resetVisualizationSection() {
            var self = this;

            self.visualizationForm["units"] = {
                speeches: false,
                dialogs: false,
                letters: false,
                //                    turns: false,
                acts: false,
                subacts: false
            };
        }
    },
    components: {
        [Breadcrumb.name]: Breadcrumb,
        [Loading.name]: Loading
    }
};
</script>

<style scoped>
.v-data-table tr {
    /*height: 20px !important;*/
    border: 1px solid black !important;
}

.v-data-table td {
    font-size: 12px;
    padding: 0 12px;
    /*height: 20px !important;*/
}

.v-data-table th {
    font-size: 18px;
    padding: 0 12px;
}

.noselect {
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    -khtml-user-select: none;
    /* Konqueror HTML */
    -moz-user-select: none;
    /* Old versions of Firefox */
    -ms-user-select: none;
    /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently
                                        supported by Chrome, Edge, Opera and Firefox */
}

.transparent>.table,
.transparent>.table__overflow>.table,
.transparent>.table>.datatable__actions {
    background-color: #fde19a;
}

.selected {
    background-color: #fde19a !important;
}

.directSpeech td {
    background-color: #8fbc8f5c !important;
}

.directSpeech interv_contents {
    font-style: italic;
}

.observation {
    background-color: #d6e7ea !important;
}

.v-data-table td {
    padding: 0 10px;
}

.v-data-table td p {
    margin: 3px 0;
}

.v-data-table td i {
    font-weight: 300;
}

.speaker_turn_count {
    color: #e95e38;
    font-size: 95%;
}

.speaker_key {
    color: black;
}

.speaker_int_count {
    color: cornflowerblue;
    font-size: 95%;
}

.v-data-table__wrapper {
    overflow-x: visible;
    overflow-y: visible;
}

.letter-image-container {
    width: 100%;
    height: 100%;
}

.letter-image-container img {
    width: 100%;
    height: 100%;
}
</style>
